/* istanbul ignore file */
/**
 * Sitewide UTM capture — the one-line counterpart to `iframe.ts`/`payout-popup.ts`.
 *
 * Those two forward the CURRENT page's UTM params onto the widget iframe, but
 * an ad click often lands on a page that doesn't have the widget at all (the
 * homepage, say), and in-site navigation to the page that does typically drops
 * the query string. This script stores whatever UTM params are present into a
 * first-party cookie (`captureUtmParams` in `attribution.ts`) so they survive
 * that hop — `withAttribution` reads the cookie back when building the widget
 * iframe's URL.
 *
 * Unlike the other entrypoints, this one belongs on EVERY page of the host
 * site, not just the page embedding a widget — e.g. the theme's global
 * header/footer, or a sitewide GTM tag:
 *
 *   <script src="https://lead-form.maxretail.app/utm-capture.js" defer></script>
 */
import { captureUtmParams } from './attribution.js'

captureUtmParams()
